import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button, Dialog, Space } from 'tdesign-react';
import { modifyHosts } from '@/slices/execFlowSlice';
import HostTable from '@/pages/Maintenance/Resource/Host/components/HostTable';

function SelectHostModal({
  visible,
  handleClose,
  clusterId,
  modifyHosts,
  hostsList,
  goIndex,
  steps,
  currentIndex,
}) {
  const [rows, setRows] = useState([]);

  const currentStep = steps[currentIndex];
  const prevStep = steps[currentIndex - 1];
  const nextStep = steps[currentIndex + 1];

  const currentHosts = useMemo(() => {
    if (currentStep) {
      return hostsList.find((item) => item.stepId === currentStep.stepId)?.hosts || [];
    } else {
      return [];
    }
  }, [currentStep, hostsList]);

  useEffect(() => {
    if (visible) {
      setRows(currentHosts);
    }
  }, [visible, currentIndex, currentHosts]);

  const onConfirm = () => {
    handleClose();
    modifyHosts({
      currentStep,
      hosts: rows,
    });
  };

  const onSelectChange = (value, { selectedRowData }) => {
    setRows(selectedRowData);
  };

  const goStep = (toStepIndex) => {
    modifyHosts({
      currentStep,
      hosts: rows,
    });
    goIndex(toStepIndex);
  };

  return (
    <Dialog
      header={currentStep?.prettyText}
      visible={visible}
      footer={
        <Footer>
          <Space>
            <Button
              theme={prevStep ? 'primary' : 'default'}
              disabled={!prevStep}
              variant='outline'
              onClick={() => goStep(currentIndex - 1)}
            >
              上一步骤
            </Button>

            <Button
              theme={nextStep ? 'primary' : 'default'}
              disabled={!nextStep}
              variant='outline'
              onClick={() => goStep(currentIndex + 1)}
            >
              下一步骤
            </Button>

            <Button onClick={onConfirm}>确认</Button>
          </Space>
        </Footer>
      }
      placement='center'
      onClose={() => handleClose()}
      destroyOnClose
      width={'80%'}
    >
      <HostTable
        clusterId={clusterId}
        selectOnRowClick
        selectedRowData={rows}
        onSelectChange={onSelectChange}
      />
    </Dialog>
  );
}

export default connect(
  (state) => ({
    hostsList: state.execFlow.hostsList,
  }),
  {
    modifyHosts,
  },
)(SelectHostModal);

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
